import React from "react";
import { usePreregisterData } from "pages/registration/registration.service";
import { Navigate, useNavigate } from "react-router-dom";
import EmailValid from "assets/images/svg/email_valid_art.svg";
import { useTranslation } from "react-i18next";

function CongratulationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { preregisterData ,setPreregisterData} = usePreregisterData();


  if (!preregisterData) return <Navigate to="/register" />;

  function handleGoToLogin() {
    setPreregisterData(undefined);
    navigate("/login");
  }

  return (
    <div className="registration link-send">
      <div className="row">
        <div className="col-lg-8 col-md-12 mx-auto">
          <div className="row">
            <div className="col-lg-6 col-md-4">
              <img
                className="background"
                src={EmailValid}
                alt="background"
              />
            </div>
            <div className="col-lg-6 col-md-8">
              <div className="box-linksend">
                <h1>{t("congratulations")}</h1>
                <p>
                  {t(
                    "Congratulations, your email has been confirmed and your account has been successfully activated. You can login to your account now."
                  )}
                </p>
                <button onClick={handleGoToLogin} className="btn-blue">
                  {t("login")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CongratulationPage;
